/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_DROPDOWN': {
    width: 16,
    height: 16,
    viewBox: '0 0 17 10',
    data: '<path pid="0" _fill="currentColor" d="M16.52 1.52L15.46.46 8.5 7.42 1.54.46.48 1.52 8.5 9.54l8.02-8.02z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_DROPDOWN.js